import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { LineChart, Loader2, CheckCircle, XCircle } from 'lucide-react';
import { BrandLogo } from '../../components/common/BrandLogo';
import { verifyEmail } from '../../services/api/auth';

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [state, setState] = useState<'loading' | 'ok' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) { setState('error'); setMessage('Tautan verifikasi tidak valid.'); return; }
    verifyEmail(token)
      .then((r) => { setState('ok'); setMessage(r.message); })
      .catch(() => { setState('error'); setMessage('Tautan verifikasi tidak valid atau sudah kedaluwarsa. Silakan minta tautan baru.'); });
  }, [token]);

  return (
    <div className="min-h-screen bg-[#050914] flex items-center justify-center p-4 relative overflow-hidden">
      <div className="absolute w-[800px] h-[800px] bg-cyan-500/10 blur-[120px] rounded-full top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none" />
      <div className="w-full max-w-md bg-white/[0.03] backdrop-blur-2xl border border-white/10 rounded-3xl p-8 sm:p-12 relative z-10 shadow-2xl text-center" data-testid="verify-email-page">
        <div className="mb-8 flex justify-center">
          <BrandLogo />
        </div>
        {state === 'loading' && <Loader2 className="w-8 h-8 text-cyan-400 animate-spin mx-auto" strokeWidth={1.5} />}
        {state === 'ok' && (
          <>
            <CheckCircle className="w-14 h-14 text-emerald-400 mx-auto mb-4" strokeWidth={1.5} />
            <h1 className="text-xl font-medium text-white mb-2">Email Terverifikasi</h1>
            <p className="text-white/60 text-sm mb-6">{message}</p>
            <Link to="/" data-testid="verify-login-link" className="inline-block bg-cyan-400 text-[#050914] font-medium px-6 py-2.5 rounded-lg hover:bg-cyan-300 transition-colors">Masuk Sekarang</Link>
          </>
        )}
        {state === 'error' && (
          <>
            <XCircle className="w-14 h-14 text-red-400 mx-auto mb-4" strokeWidth={1.5} />
            <h1 className="text-xl font-medium text-white mb-2">Verifikasi Gagal</h1>
            <p className="text-white/60 text-sm mb-6">{message}</p>
            <Link to="/" className="text-cyan-400 hover:text-cyan-300 text-sm">Kembali ke Login</Link>
          </>
        )}
      </div>
    </div>
  );
}
